/* eslint-disable react-hooks/exhaustive-deps */
import { SimpleElectricityAgreement } from 'models/electricity/agreement';
import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthenticationContext, CustomerPermission } from 'services/context/authentication.context';
import ElectricityAgreementService from 'services/electricity/electricity-agreement.service';

export default function DashboardElectricityCta() {
  const [pendingAgreements, setPendingAgreements] = useState<SimpleElectricityAgreement[] | null>(null);
  const { state, hasPermission } = useContext(AuthenticationContext);

  useEffect(() => {
    if (state.customerId) {
      getPendingAgreements(state.customerId);
    }
  }, [state.customerId]);

  const getPendingAgreements = async (customerId: number) => {
    try {
      ElectricityAgreementService.getPendingElectricityAgreements(
        customerId
      ).then((res) => setPendingAgreements(res));
    } catch (e) {
      console.error(e);
    }
  };

  const hasPendingAgreements = !!pendingAgreements?.length;
  const hasAgreements =
    !!state.customer!.activeElectricityAgreementsCount ||
    state.customer!.hasPendingElectricityAgreements;

  if (hasAgreements) {
    return (
      <Card className="d-flex flex-col p-4 mb-4">
        <div className="d-flex flex-row flex-nowrap align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="icon__electricity mr-2"></i>
            <strong className="u-fs-16">
              {hasPendingAgreements
                ? 'Teile on tehtud elektrilepingu pakkumine.'
                : 'Sinu elektrimüüja on eTerminal.'}
            </strong>
          </div>
          {pendingAgreements?.length === 1 && hasPermission(CustomerPermission.WEB_ADMIN) ? (
            <div>
              <Link
                to={`/elekter/vaata-pakkumist/${pendingAgreements[0].id}`}
                className="btn btn-secondary-medium d-flex align-items-center text-nowrap"
              >
                Vaata pakkumist
                <i className="icon__arrow-right bg-dark ml-2" />
              </Link>
            </div>
          ) : (
            <Link
              to="/lepingud"
              className="btn btn-secondary-medium d-flex align-items-center text-nowrap"
            >
              Vaata lepinguid
              <i className="icon__arrow-right bg-dark ml-2" />
            </Link>
          )}
        </div>
      </Card>
    );
  }

  return (
    <div className="dashboard-electricity__container--no-agreements mb-3">
      <h2 className="dashboard-electricity__title">
        Liitu Terminali elektriteenustega!
      </h2>
      <ul className="dashboard-electricity__list">
        <li className="dashboard-electricity__list__item">
          Sinule sobiv elektripakett
        </li>
        <li className="dashboard-electricity__list__item">
          Taastuvenergial põhinev elektriteenus
        </li>
        <li className="dashboard-electricity__list__item">Kindel partner</li>
      </ul>
      <div className="d-flex mt-auto">
        {
          hasPermission(CustomerPermission.WEB_ADMIN) ? (
            <Link
              to="/elekter/leping"
              className="btn btn-primary btn-lg d-flex align-items-center"
            >
              Sõlmi elektrileping<i className="icon__arrow-right ml-2"></i>
            </Link>
          ) : null
        }
      </div>
    </div>
  );
}
